export const CheckCircle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 17"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6668 8.4944C14.6668 12.1764 11.6822 15.1611 8.00016 15.1611C4.31816 15.1611 1.3335 12.1764 1.3335 8.4944C1.3335 4.8124 4.31816 1.82773 8.00016 1.82773C11.6822 1.82773 14.6668 4.8124 14.6668 8.4944ZM10.6868 6.4744C10.7805 6.56815 10.8331 6.69523 10.8331 6.82773C10.8331 6.96023 10.7805 7.08731 10.6868 7.18106L7.3535 10.5144C7.25975 10.608 7.13266 10.6606 7.00016 10.6606C6.86766 10.6606 6.74058 10.608 6.64683 10.5144L5.3135 9.18106C5.26437 9.13529 5.22497 9.08009 5.19764 9.01875C5.17031 8.95742 5.15562 8.89121 5.15444 8.82408C5.15325 8.75694 5.1656 8.69026 5.19075 8.628C5.21589 8.56574 5.25332 8.50918 5.3008 8.4617C5.34828 8.41422 5.40484 8.37679 5.4671 8.35165C5.52936 8.3265 5.59604 8.31415 5.66318 8.31533C5.73031 8.31652 5.79652 8.33121 5.85785 8.35854C5.91919 8.38587 5.97439 8.42527 6.02016 8.4744L7.00016 9.45439L8.49016 7.9644L9.98016 6.4744C10.0739 6.38076 10.201 6.32817 10.3335 6.32817C10.466 6.32817 10.5931 6.38076 10.6868 6.4744Z"
      fill="currentColor"
    />
  </svg>
);
